<template>
  <Teleport to="body">
    <div v-if="showModal" class="fixed inset-0 z-70 lg:hidden">
      <transition
        enter-active-class="transition-opacity duration-300 ease-out"
        leave-active-class="transition-opacity duration-200 ease-in"
        enter-from-class="opacity-0"
        enter-to-class="opacity-100"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
        appear
        @before-leave="backdropLeaving = true"
        @after-leave="onBackdropLeft"
      >
        <div
          v-if="showBackdrop"
          class="fixed inset-0 bg-black/50"
          aria-hidden="true"
          @click="close"
        />
      </transition>

      <transition
        enter-active-class="transition-transform duration-300 ease-out"
        leave-active-class="transition-transform duration-200 ease-in"
        enter-from-class="translate-x-full"
        enter-to-class="translate-x-0"
        leave-from-class="translate-x-0"
        leave-to-class="translate-x-full"
        appear
        @before-leave="panelLeaving = true"
        @after-leave="onPanelLeft"
      >
        <div
          v-if="showPanel"
          class="fixed inset-y-0 right-0 flex w-full flex-col bg-white shadow-2xl"
          role="dialog"
          aria-modal="true"
          :aria-label="title"
          @click.stop
        >
          <div class="flex shrink-0 items-start justify-between gap-3 border-b border-neutral-200 px-4 pb-3 pt-4">
            <div class="min-w-0 flex-1">
              <h2 class="text-2xl font-medium leading-8 tracking-[-0.02em]">
                {{ title }}
              </h2>
              <p v-if="subtitle" class="mt-0.5 text-sm leading-5 text-neutral-900">
                {{ subtitle }}
              </p>
            </div>
            <button
              type="button"
              class="flex size-10 shrink-0 items-center justify-center rounded-lg text-neutral-500 transition-colors hover:bg-neutral-100 hover:text-neutral-900 p-2.5"
              :aria-label="$t('common.close')"
              @click="close"
            >
              <svg class="size-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 6l12 12M18 6L6 18" />
              </svg>
            </button>
          </div>

          <div class="min-h-0 flex-1 overflow-y-auto">
            <slot />
          </div>
        </div>
      </transition>
    </div>
  </Teleport>
</template>

<script>
export default {
  name: 'BookingSlideOver',
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
  emits: ['close'],
  data() {
    return {
      showModal: false,
      showBackdrop: false,
      showPanel: false,
      backdropLeaving: false,
      panelLeaving: false,
    };
  },
  watch: {
    open: {
      handler(value) {
        if (value) {
          this.show();
        } else {
          this.close();
        }
      },
      immediate: true,
    },
  },
  created() {
    document.addEventListener('keydown', this.onEscape);
  },
  unmounted() {
    document.removeEventListener('keydown', this.onEscape);
    document.body.style.removeProperty('overflow');
  },
  methods: {
    show() {
      this.showModal = true;
      this.showBackdrop = true;
      this.showPanel = true;
      document.body.style.setProperty('overflow', 'hidden');
    },
    close() {
      this.showBackdrop = false;
      this.showPanel = false;
      document.body.style.removeProperty('overflow');
    },
    onBackdropLeft() {
      this.backdropLeaving = false;
      this.maybeHideModal();
    },
    onPanelLeft() {
      this.panelLeaving = false;
      this.maybeHideModal();
    },
    maybeHideModal() {
      if (!this.backdropLeaving && !this.panelLeaving && !this.showBackdrop && !this.showPanel) {
        this.showModal = false;
        this.$emit('close');
      }
    },
    onEscape(event) {
      if (this.open && event.key === 'Escape') {
        this.close();
      }
    },
  },
};
</script>
